$(document).ready(() => {
  // Konstanten für DOM-Selektoren und häufig verwendete Strings
  const SELECTORS = {
    filterItem: '.filter-item',
    publikationCard: '.publikationen-grid .grid-element',
    allFilter: '[data-filter="alle"], [data-filter="all"]'
  };

  const CLASSES = {
    active: 'active-filter',
    inactive: 'inactive-filter',
    filteredIn: 'filtered-in',
    filteredOut: 'filtered-out'
  };

  const ALL_FILTER_TYPES = ['alle', 'all'];

  const filterItems = $(SELECTORS.filterItem);
  const publikationCards = $(SELECTORS.publikationCard);
  const allFilterButton = $(SELECTORS.allFilter);

  const toggleFilterState = (clickedFilter) => {
    const filterType = clickedFilter.data('filter');
    const isAlreadyActive = clickedFilter.hasClass(CLASSES.active);
    const isAllFilter = ALL_FILTER_TYPES.includes(filterType);
    
    if (isAlreadyActive && !isAllFilter) {
      // Deaktiviere aktuellen Filter und aktiviere "Alle"/"All"
      allFilterButton.addClass(CLASSES.active).removeClass(CLASSES.inactive);
      clickedFilter
        .removeClass(CLASSES.active)
        .addClass(CLASSES.inactive);
      
      applyFilter(filterType, true);
    } else {
      // Aktiviere neuen Filter
      allFilterButton
        .removeClass(CLASSES.active)
        .addClass(CLASSES.inactive);
      
      filterItems
        .removeClass(CLASSES.active)
        .addClass(CLASSES.inactive);
      
      clickedFilter
        .removeClass(CLASSES.inactive)
        .addClass(CLASSES.active);
      
      applyFilter(filterType, false);
    }
  };

  const applyFilter = (filterType, isDeactivating) => {
    if (isDeactivating || ALL_FILTER_TYPES.includes(filterType)) {
      // Zeige alle Karten
      publikationCards
        .removeClass(CLASSES.filteredOut)
        .removeClass(CLASSES.filteredIn);
      return;
    }

    // Filtere Karten
    publikationCards.each((_, card) => {
      const $card = $(card);
      if ($card.hasClass(filterType)) {
        $card
          .removeClass(CLASSES.filteredOut)
          .addClass(CLASSES.filteredIn);
      } else {
        $card
          .removeClass(CLASSES.filteredIn)
          .addClass(CLASSES.filteredOut);
      }
    });
  };

  // Event Listener
  filterItems.on('click', function() {
    toggleFilterState($(this));
  });
}); 